const compact = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(0)}K`;
  return n.toFixed(0);
};

// Explains which spend the savings estimate is sized on (Non-Addressable is excluded)
export function savingsBasisNote(sav, cs, fmt = compact) {
  if (!sav || sav.savings_base_spend == null) return '';
  let note = `Based on addressable spend of ${cs}${fmt(sav.savings_base_spend)}`;
  if (sav.non_addressable_spend > 0) note += ` (excludes ${cs}${fmt(sav.non_addressable_spend)} non-addressable)`;
  if (sav.unclassified_spend > 0) note += `; ${cs}${fmt(sav.unclassified_spend)} has no addressability flag and is treated as addressable (unverified)`;
  return `${note}.`;
}
